// Precomputed with Code Hike’s dark-plus TSX highlighting; no highlighter is shipped.
export const editorCode: readonly (readonly (readonly [string, string])[])[] = [
	[
		['import', '#C586C0'],
		[' ', '#D4D4D4'],
		['{', '#D4D4D4'],
		['Audio', '#9CDCFE'],
		['}', '#D4D4D4'],
		[' ', '#D4D4D4'],
		['from', '#C586C0'],
		[' ', '#D4D4D4'],
		["'@remotion/media'", '#CE9178'],
		[';', '#D4D4D4'],
	],
	[
		['import', '#C586C0'],
		[' ', '#D4D4D4'],
		['{', '#D4D4D4'],
		['TransitionSeries', '#9CDCFE'],
		['}', '#D4D4D4'],
		[' ', '#D4D4D4'],
		['from', '#C586C0'],
		[' ', '#D4D4D4'],
		["'@remotion/transitions'", '#CE9178'],
		[';', '#D4D4D4'],
	],
	[
		['import', '#C586C0'],
		[' ', '#D4D4D4'],
		['{', '#D4D4D4'],
		['IntroScene', '#9CDCFE'],
		['}', '#D4D4D4'],
		[' ', '#D4D4D4'],
		['from', '#C586C0'],
		[' ', '#D4D4D4'],
		["'./scenes/Intro'", '#CE9178'],
		[';', '#D4D4D4'],
	],
	[
		['import', '#C586C0'],
		[' ', '#D4D4D4'],
		['{', '#D4D4D4'],
		['LightLeaksScene', '#9CDCFE'],
		['}', '#D4D4D4'],
		[' ', '#D4D4D4'],
		['from', '#C586C0'],
		[' ', '#D4D4D4'],
		["'./scenes/LightLeaks'", '#CE9178'],
		[';', '#D4D4D4'],
	],
	[
		['import', '#C586C0'],
		[' ', '#D4D4D4'],
		['{', '#D4D4D4'],
		['OutroScene', '#9CDCFE'],
		['}', '#D4D4D4'],
		[' ', '#D4D4D4'],
		['from', '#C586C0'],
		[' ', '#D4D4D4'],
		["'./scenes/Outro'", '#CE9178'],
		[';', '#D4D4D4'],
	],
	[],
	[
		['export', '#C586C0'],
		[' ', '#D4D4D4'],
		['const', '#569CD6'],
		[' ', '#D4D4D4'],
		['WhatsNew', '#DCDCAA'],
		[' ', '#D4D4D4'],
		['= ()', '#D4D4D4'],
		[' ', '#D4D4D4'],
		['=>', '#569CD6'],
		[' ', '#D4D4D4'],
		['{', '#D4D4D4'],
	],
	[
		['  ', '#D4D4D4'],
		['return', '#C586C0'],
		[' ', '#D4D4D4'],
		['(', '#D4D4D4'],
	],
	[
		['    ', '#D4D4D4'],
		['<>', '#808080'],
	],
	[
		['      ', '#D4D4D4'],
		['<', '#808080'],
		['TransitionSeries', '#4EC9B0'],
		[' ', '#D4D4D4'],
		['name', '#9CDCFE'],
		['=', '#D4D4D4'],
		['"Chapters"', '#CE9178'],
		['>', '#808080'],
	],
	[
		['        ', '#D4D4D4'],
		['<', '#808080'],
		['TransitionSeries.Sequence', '#4EC9B0'],
	],
	[
		['          ', '#D4D4D4'],
		['name', '#9CDCFE'],
		['=', '#D4D4D4'],
		['"Intro"', '#CE9178'],
	],
	[
		['          ', '#D4D4D4'],
		['durationInFrames', '#9CDCFE'],
		['=', '#D4D4D4'],
		['{', '#569CD6'],
		['250', '#B5CEA8'],
		['}', '#569CD6'],
	],
	[
		['        ', '#D4D4D4'],
		['>', '#808080'],
	],
	[
		['          ', '#D4D4D4'],
		['<', '#808080'],
		['IntroScene', '#4EC9B0'],
		[' ', '#D4D4D4'],
		['/>', '#808080'],
	],
	[
		['        ', '#D4D4D4'],
		['</', '#808080'],
		['TransitionSeries.Sequence', '#4EC9B0'],
		['>', '#808080'],
	],
	[
		['        ', '#D4D4D4'],
		['<', '#808080'],
		['TransitionSeries.Sequence', '#4EC9B0'],
	],
	[
		['          ', '#D4D4D4'],
		['name', '#9CDCFE'],
		['=', '#D4D4D4'],
		['"Light leaks"', '#CE9178'],
	],
	[
		['          ', '#D4D4D4'],
		['durationInFrames', '#9CDCFE'],
		['=', '#D4D4D4'],
		['{', '#569CD6'],
		['864', '#B5CEA8'],
		['}', '#569CD6'],
	],
	[
		['        ', '#D4D4D4'],
		['>', '#808080'],
	],
	[
		['          ', '#D4D4D4'],
		['<', '#808080'],
		['LightLeaksScene', '#4EC9B0'],
		[' ', '#D4D4D4'],
		['/>', '#808080'],
	],
	[
		['        ', '#D4D4D4'],
		['</', '#808080'],
		['TransitionSeries.Sequence', '#4EC9B0'],
		['>', '#808080'],
	],
	[
		['        ', '#D4D4D4'],
		['<', '#808080'],
		['TransitionSeries.Sequence', '#4EC9B0'],
	],
	[
		['          ', '#D4D4D4'],
		['name', '#9CDCFE'],
		['=', '#D4D4D4'],
		['"Outro"', '#CE9178'],
	],
	[
		['          ', '#D4D4D4'],
		['durationInFrames', '#9CDCFE'],
		['=', '#D4D4D4'],
		['{', '#569CD6'],
		['180', '#B5CEA8'],
		['}', '#569CD6'],
	],
	[
		['        ', '#D4D4D4'],
		['>', '#808080'],
	],
	[
		['          ', '#D4D4D4'],
		['<', '#808080'],
		['OutroScene', '#4EC9B0'],
		[' ', '#D4D4D4'],
		['/>', '#808080'],
	],
	[
		['        ', '#D4D4D4'],
		['</', '#808080'],
		['TransitionSeries.Sequence', '#4EC9B0'],
		['>', '#808080'],
	],
	[
		['      ', '#D4D4D4'],
		['</', '#808080'],
		['TransitionSeries', '#4EC9B0'],
		['>', '#808080'],
	],
	[
		['      ', '#D4D4D4'],
		['<', '#808080'],
		['Audio', '#4EC9B0'],
		[' ', '#D4D4D4'],
		['name', '#9CDCFE'],
		['=', '#D4D4D4'],
		['"Score"', '#CE9178'],
		[' ', '#D4D4D4'],
		['src', '#9CDCFE'],
		['=', '#D4D4D4'],
		['"score.wav"', '#CE9178'],
		[' ', '#D4D4D4'],
		['/>', '#808080'],
	],
	[
		['    ', '#D4D4D4'],
		['</>', '#808080'],
	],
	[
		['  ', '#D4D4D4'],
		[');', '#D4D4D4'],
	],
	[['};', '#D4D4D4']],
];
